var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home_content"},[_c('div',{staticClass:"divcover_left"},[_c('listContent',{attrs:{"data":_vm.$store.state.withRank.rankData.data}})],1),_c('div',{staticClass:"divcover_right"},[_c('listFeature')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }